import { useEffect, useState } from 'react';
import { CustomSlide } from '../../../models/slides/CustomSlide';
import { fadeAnimation, fadeAnimationName } from '../../../utils/fadeAnimation';
import { sanitizeUrl } from 'shared-widget-components/src/utils/sanitizeUrl';
import { truncateHtml } from 'shared-widget-components/src/utils/truncateHtml';
import { CustomSlideButton } from './CustomSlideButton';

interface CustomSlideContentProps {
  slides: CustomSlide[];
  textColor: string;
  buttonColor: string;
  buttonTextColor: string;
  currentIndex: number;
}

/**
 * CustomSlideContent component
 * this component is responsible for rendering the content of the custom slide
 * @param slides - the list of the carousel slides
 * @param currentIndex - the index of the currently active slide
 * @param textColor - the color of the text
 * @param buttonColor - the color of the button
 * @param buttonTextColor - the color of the button text
 * @returns CustomSlideContent component
 */

const CustomSlideContent = ({ slides, buttonColor, buttonTextColor, textColor, currentIndex }: CustomSlideContentProps) => {
  //@ts-ignore
  const languageCode = window.currentLanguageCode;

  // the content of the slide on the current language || hu content if no content for the current language
  const defaultContent = slides[currentIndex].content[languageCode] || slides[currentIndex].content['hu'];

  const [slideContent, setSlideContent] = useState(defaultContent);

  useEffect(() => {
    //  if there is no content for the current language, return
    if (!slides[currentIndex] || !slides[currentIndex].content[languageCode]) return;
    //  set the content of the slide on the current language
    setSlideContent(slides[currentIndex].content[languageCode]);
  }, [slides, languageCode]);

  // a description rövidítése megadott karakterszámra
  const truncatedDescription = truncateHtml(slideContent.description, 120);

  return (
    <div className='min-[350px]:mt-0 sm:mt-2 md:mt-4 h-full flex flex-col justify-between' style={{ animation: fadeAnimation, animationName: fadeAnimationName }}>
      <div className='h-3/4 min-[350px]:mb-3 sm:mb-1'>
        <h1
          className='min-[350px]:text-[20px] block overflow-hidden whitespace-normal md:text-[24px] min-[1200px]:text-[28px] font-semibold mb-4 mt-2 font-body'
          style={{ color: textColor, display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2 }}
        >
          {slideContent.title}
        </h1>
        <p className='min-[350px]:text-[14px] font-medium mb-3 sm:text-[16px] mr-2 w-full font-body' style={{ color: textColor }}>
          {truncatedDescription}
        </p>
      </div>

      <div className='h-1/4 '>
        <CustomSlideButton slideContent={slideContent} buttonColor={buttonColor} buttonTextColor={buttonTextColor} />
      </div>
    </div>
  );
};

export default CustomSlideContent;
